/* Raid Supply - trust line normaliser (12-09-2026)
   Makes every trust row read 4.9 / 5 stars + "4.9/5 - 11,537 verified reviews".
   Runs on the templates whose markup has not been edited in place; it is
   idempotent, so rows already carrying .rs49 are left alone. */
(function () {
  var TEXT = '4.9/5 · 11,537 verified reviews';
  var SUB = '<strong>11,537 verified reviews</strong> from buyers on our eBay store, rated <strong>4.9 out of 5</strong>. Here are a few of them.';

  function clipLast(row) {
    if (!row || row.querySelector('.rs49')) return;
    var kids = row.children, svgs = [];
    for (var i = 0; i < kids.length; i++) {
      if (kids[i].tagName && kids[i].tagName.toLowerCase() === 'svg') svgs.push(kids[i]);
    }
    if (svgs.length !== 5) return;
    var last = svgs[4];
    var wrap = document.createElement('span');
    wrap.className = 'rs49';
    var bg = last.cloneNode(true);
    var fg = last.cloneNode(true);
    bg.setAttribute('class', 'rs49b');
    fg.setAttribute('class', 'rs49f');
    wrap.appendChild(bg);
    wrap.appendChild(fg);
    last.parentNode.replaceChild(wrap, last);
  }

  function lastSpan(row) {
    var kids = row.children;
    for (var i = kids.length - 1; i >= 0; i--) {
      if (kids[i].tagName.toLowerCase() === 'span' && !kids[i].querySelector('svg')) return kids[i];
    }
    return null;
  }

  function run() {
    var rows = document.querySelectorAll(
      '.pdm-stars[aria-hidden="true"], .rs-stars[aria-hidden="true"], .rs-rev__stars[aria-hidden="true"], .rs-news-stars[aria-hidden="true"]'
    );
    for (var i = 0; i < rows.length; i++) clipLast(rows[i]);

    var uni = document.querySelectorAll('.raid-stars');
    for (var u = 0; u < uni.length; u++) {
      if (uni[u].querySelector('.rs49-txt')) continue;
      if (uni[u].textContent.replace(/\s/g, '') === '★★★★★') {
        uni[u].innerHTML = '★★★★<span class="rs49-txt">★</span>';
      }
    }

    var trust = document.querySelectorAll('.pdm__trust, .rs-master__trust, .raid-review-line, .rs-news-trust');
    for (var t = 0; t < trust.length; t++) {
      var sp = lastSpan(trust[t]);
      if (!sp) continue;
      var txt = sp.textContent.trim();
      if (txt === TEXT) continue;
      if (/review|customer/i.test(txt)) sp.textContent = TEXT;
    }

    var subs = document.querySelectorAll('.rs-rev__sub');
    for (var s = 0; s < subs.length; s++) {
      if (/10,000|20,000|1,670/.test(subs[s].textContent)) subs[s].innerHTML = SUB;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);
})();
